<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title has-text-centered">
        Ajuste do nome
      </p>
    </header>

    <section class="modal-card-body">
      <b-field label="Nome" label-position="on-border">
        <b-input v-model="n" type="text" placeholder="Nome"></b-input>
      </b-field>
    </section>

    <footer class="modal-card-foot">
      <button class="button is-success" type="button" @click="save">
        Salvar
      </button>

      <button class="button" type="button" @click="$parent.close()">
        Cancelar
      </button>
    </footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      n: ""
    };
  },

  props: ["product"],

  components: {},

  methods: {
    save() {
      this.$emit("on-update", { n: this.n, b: this.product.b });
    }
  },

  mounted() {
    if (this.product) {
      this.n = this.product.n;
    }
  }
};
</script>
